export const countryCodeOption = [
  { name: 'IN', code: 91 },
  { name: 'US', code: 1 }
];
